<div
  v-if="loading"
  class="app-loader d-flex flex-column align-items-center justify-content-center text-center py-5"
  :class="{ 'loader app-loader-overlay': overlay }"
  role="status"
  aria-live="polite"
>
  <video
    v-show="loader_video_ready"
    class="app-loader-media"
    :src="loader_src"
    autoplay
    loop
    muted
    playsinline
    aria-hidden="true"
    @loadeddata="mark_loader_video_ready"
    @error="mark_loader_video_failed"
  ></video>
  <div v-if="!loader_video_ready" class="app-loader-fallback spinner-border text-primary" role="presentation"></div>
  <span class="visually-hidden">{{ label }}</span>
</div>
